module.exports = __webpack_public_path__ + "img/RAS-Mini.92113347.png";